import type { SolidShapeColor } from "./solid-shape.types";

export const colorMap: Record<SolidShapeColor, string> = {
  "bright-blue": "#5375CF",
  "light-green": "#9BD7D2",
  turquoise: "#00A399",
  peach: "#FF946A",
  avocado: "#C6E57D",
  "sky-blue": "#90A8ED",
  orange: "#EFAC53",
  sea: "#008AAA",
  mint: "#68C187",
  yellow: "#FFC627",
  cobalt: "#3B72FF",
  ocean: "#1A3C82",
  afternoon: "#B8DBF7",
  white: "#FFFFFF",
};
